import { createPortal } from 'react-dom';
import { useLayoutEffect, useState } from 'react';
function createWrapperAndAppendToBody(wrappedId) {
    var wrapperElement = document.createElement('div');
    wrapperElement.setAttribute('id', wrappedId);
    document.body.appendChild(wrapperElement);
    return wrapperElement;
}
function Portal(_a) {
    var children = _a.children, _b = _a.wrappedId, wrappedId = _b === void 0 ? 'react-portal-wrapper' : _b;
    var _c = useState(null), wrapperElement = _c[0], setWrapperElement = _c[1];
    useLayoutEffect(function () {
        var element = document.getElementById(wrappedId);
        var systemCreated = false;
        if (!element) {
            systemCreated = true;
            element = createWrapperAndAppendToBody(wrappedId);
        }
        setWrapperElement(element);
        return function () {
            if (systemCreated && element.parentNode) {
                element.parentNode.removeChild(element);
            }
        };
    }, [wrappedId]);
    if (wrapperElement === null)
        return null;
    return createPortal(children, wrapperElement);
}
export default Portal;
